export default function Footer() {
  return (
    <footer className="bg-carbon text-papel py-14 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap justify-between items-baseline gap-6 mb-7">
          <span className="font-display font-display-axes text-2xl font-medium relative inline-block">
            Kirkjoserey
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-senal align-super ml-1" />
          </span>
          <span className="font-display italic text-sm text-niebla">
            Detrás de Baqueano.
          </span>
        </div>
        <div className="h-px bg-sendero/40 mb-5" />
        <div className="flex flex-wrap gap-7 font-mono text-[10px] tracking-[0.2em] uppercase text-niebla">
          <a href="#contacto" className="hover:text-papel transition-colors">
            Formulario de contacto
          </a>
          <span>Buenos Aires · AR</span>
          <span>Lic. en Sistemas</span>
          <span>© 2026</span>
        </div>
      </div>
    </footer>
  );
}
